import { Observable } from 'rxjs';
import { startSubmit, stopSubmit, reset } from 'redux-form/immutable';

import UserApi from 'entities/user/api';

import { REGISTER_FORM_IDENTIFIER, RESET_DIALOG, SAVE } from './constants';
import { saveSuccessAction, saveFailedAction } from './actions';

const save = (action$) =>
  action$.ofType(SAVE).mergeMap((payload) => {
    const { data } = payload;

    // @NOTE-RT: only send 1 password
    data.password = data.password1;
    delete data.password1;
    delete data.password2;

    if (!data.nonprofitName) {
      data.nonprofitId = data.nonprofit?.nonprofitId;
    }
    delete data.nonprofit;

    return Observable.concat(
      Observable.of(startSubmit('register')),
      UserApi.createOrganizerClaimingNonprofit(data).mergeMap((newUser) => [
        saveSuccessAction(newUser?.emailVerificationRequested),
        stopSubmit(REGISTER_FORM_IDENTIFIER),
        reset(REGISTER_FORM_IDENTIFIER),
      ])
    ).catch((e) => {
      if (e.responseBody) {
        return Observable.of(e.responseBody).mergeMap((resp) => [
          saveFailedAction(
            e,
            resp?.errors?.[0]?.extensions?.errorCode || 'saveFailed',
            resp?.errors?.[0]?.extensions?.errorCode || resp.message,
            resp?.errors?.[0]?.extensions?.duplicateNonprofitId,
            resp?.errors?.[0]?.extensions?.duplicateNonprofitName
          ),
        ]);
      }
      return Observable.of(saveFailedAction(e, 'saveFailed'));
    });
  });

const resetDialog = (action$) =>
  action$.ofType(RESET_DIALOG).mergeMap(() => [reset(REGISTER_FORM_IDENTIFIER)]);

export default [save, resetDialog];
